/* eslint-disable no-nested-ternary */
/* eslint-disable no-bitwise */
import React, { useState, useEffect } from 'react';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { collection, doc, getCountFromServer, getDoc, query, where } from 'firebase/firestore';
import { db } from '../../../../firebase.config';
import { UserAuth } from '../../../../context/AuthContext';
import CustomButton from '../../../../components/CustomButton';
import Iconify from '../../../../components/Iconify';
import LucideIcon from '../../../../components/LucideIcon';

const CampagneStats = () => {
  const { user } = UserAuth();
  const [loading, setLoading] = useState(false);
  const [emailTotal, setEmailTotal] = useState(0);
  const [adsTotal, setAdsTotal] = useState(0);

  const getData = async () => {
    try {
      setLoading(true);
      if (!user) return;

      const userDocRef = doc(db, 'organisateurs', user.uid);
      const userSnap = await getDoc(userDocRef);

      if (!userSnap.exists()) throw new Error('Organisateur non trouvé');

      const orgId = userSnap.data()?.idOrg;
      if (!orgId) throw new Error('Aucun ID d’organisation trouvé');

      // Stat campagnes email
      const emailQuery = query(
        collection(db, `organisations/${orgId}/crm/${orgId}/campagnes`),
      );
      const emailSnapshot = await getCountFromServer(emailQuery);
      setEmailTotal(emailSnapshot.data().count || 0);

      // Stat campagnes ads
      const adsQuery = query(
        collection(db, `organisations/${orgId}/crm/${orgId}/paidCampains`),
      );
      const adsSnapshot = await getCountFromServer(adsQuery);
      setAdsTotal(adsSnapshot.data().count || 0);

    } catch (error) {
      console.error('Erreur lors de la récupération des campagnes :', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      console.log(user)
      getData();
    }
  }, [user]);

  return (
    <Box
      sx={{
        padding: 2,
        height: '100%',
        width: '100%',
        bgcolor: '#D2C2FF',
        borderRadius: '10px',
        boxShadow: 5
      }}
    >
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <Iconify icon={'material-symbols-light:campaign-outline'} sx={{ width: 32, height: 32 }} />
            <Typography variant="Body2">Campagnes</Typography>
          </Stack>
        </Stack>

        {!loading ? (
          <Stack direction="row" spacing={2} alignItems="baseline">
            <Stack direction="column" alignItems="baseline">
              <Typography variant="h5">{emailTotal}</Typography>
              <Typography variant="body2">email</Typography>
              
            </Stack>
            <Stack direction="column"  alignItems="baseline">
              <Typography variant="h5">{adsTotal}</Typography>
              <Typography variant="body2">ads</Typography>
            </Stack>
          </Stack>
        ) : (
          <Stack direction="row" spacing={1}>
            <Skeleton width={40} height={30} variant="text" />
            <Skeleton width={40} height={30} variant="text" />
            <Skeleton width={40} height={30} variant="text" />
            <Skeleton width={40} height={30} variant="text" />
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default CampagneStats;
